import { useFormik } from 'formik';
import { useCallback, useState } from 'react'
import { emitUserError, emitUserInfo } from 'shared/constants/globals';
import { ROUTE } from 'shared/constants/routes_old';
import { apiResetPassword } from 'shared/modules/user/actions';
import { FormBlock, FormBox } from 'shared/Pages/common/Login/components/styles';
import { RESET_PASSWORD_VALIDATION_SCHEMA } from 'shared/Pages/common/Login/constants';
import { FormikConfig } from 'formik/dist/types';
import { FormTextField } from 'shared/_ui/form/form-text-field';
import { Button, Link, Typography } from '@mui/material'

type ResetPasswordFormValues = { email: string }

export default function ResetPassword() {
	const [done, setDone] = useState(false);
	const handleSubmit = useCallback<FormikConfig<ResetPasswordFormValues>['onSubmit']>(async ({ email }, { setSubmitting }) => {
		try {
			const res = await apiResetPassword(email);
			emitUserInfo(res);
			setDone(true);
		} catch (e) {
			emitUserError((e as Error).message, 'Reset password');
		} finally {
			setSubmitting(false);
		}
	}, []);

	const formik = useFormik<ResetPasswordFormValues>({
		initialValues: { email: '' },
		validationSchema: RESET_PASSWORD_VALIDATION_SCHEMA,
		onSubmit: handleSubmit,
	});

	if (done) {
		return (
			<FormBox>
				<Typography variant="h2">Reset password process has been started</Typography>
				<Typography textAlign="center">
					Please check your inbox for an email
				</Typography>
				<Typography textAlign="center">
					Back to <Link href={ROUTE.login}>login page</Link>
				</Typography>
			</FormBox>
		);
	}

	return (
		<FormBox id="resetPasswordForm" onSubmit={formik.handleSubmit}>
			<FormTextField
				name="email"
				type="email"
				formik={formik}
				fullWidth
				label="Email address"
				labelProps={{ position: 'top' }}
				required
				placeholder="Enter your email address"
			/>

			<Button
				type="submit"
				size="large"
				id="submitBtn"
				fullWidth
				disabled={!formik.dirty || formik.isSubmitting || !formik.isValid}
			>
				Reset
			</Button>

			<FormBlock sx={{ textAlign: 'end' }}>
				Back to
				{' '}
				<Link href={ROUTE.login}>login page</Link>
			</FormBlock>
		</FormBox>
	);
};
